// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__2FELr","selects":"Documents_selects__1pY1R"};